import config from '@/config'
import { getToken, clearLoginSession } from '@/utils/auth'

let onUnauthorized = null

export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler
}

function handleUnauthorized(message) {
  clearLoginSession()
  if (typeof onUnauthorized === 'function') {
    onUnauthorized(message)
  }
}

/**
 * 芋道 App 接口：code === 0 返回 data
 */
export async function request(options) {
  const token = getToken()
  const headers = {
    'Content-Type': 'application/json',
    ...(options.header || {})
  }
  if (token) {
    headers.Authorization = 'Bearer ' + token
  }

  let url = config.baseApi + options.url
  const method = (options.method || 'GET').toUpperCase()
  const payload = options.data || {}
  const useQueryString = method === 'GET' || method === 'DELETE'

  if (useQueryString && payload && Object.keys(payload).length) {
    const query = new URLSearchParams()
    Object.keys(payload).forEach((key) => {
      const value = payload[key]
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, String(value))
      }
    })
    const qs = query.toString()
    if (qs) {
      url += (url.includes('?') ? '&' : '?') + qs
    }
  }

  const response = await fetch(url, {
    method,
    headers,
    body: useQueryString ? undefined : JSON.stringify(payload)
  })

  let result = {}
  try {
    result = await response.json()
  } catch (e) {
    throw new Error('响应解析失败')
  }

  if (result.code === 0) {
    return result.data
  }

  if (result.code === 401) {
    handleUnauthorized(result.msg || '登录已过期')
  }

  const error = new Error(result.msg || '请求失败')
  error.code = result.code
  error.response = result
  throw error
}

/**
 * 下载文件（Excel 等二进制响应）
 */
export async function downloadRequest(options) {
  const token = getToken()
  const headers = {
    ...(options.header || {})
  }
  if (token) {
    headers.Authorization = 'Bearer ' + token
  }

  let url = config.baseApi + options.url
  const payload = options.data || {}
  const query = new URLSearchParams()
  Object.keys(payload).forEach((key) => {
    const value = payload[key]
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, String(value))
    }
  })
  const qs = query.toString()
  if (qs) {
    url += (url.includes('?') ? '&' : '?') + qs
  }

  const response = await fetch(url, {
    method: 'GET',
    headers
  })

  if (response.status === 401) {
    handleUnauthorized('登录已过期')
    throw new Error('登录已过期')
  }

  const contentType = response.headers.get('content-type') || ''
  if (contentType.includes('application/json')) {
    let result = {}
    try {
      result = await response.json()
    } catch (e) {
      throw new Error('响应解析失败')
    }
    if (result.code === 401) {
      handleUnauthorized(result.msg || '登录已过期')
    }
    throw new Error(result.msg || '导出失败')
  }

  if (!response.ok) {
    throw new Error('导出失败')
  }

  return response.blob()
}
